export async function getAction (actionHash) {
  const res = await axios.get('/decrypt-actionable', {
    params: {
      action_hash: actionHash
    }
  });

  return res.data.data.action;
}
